import React, { useContext, useMemo, useState } from 'react';
const HomePageContext = /*#__PURE__*/React.createContext({
  hidden: false,

  setHidden() {}

});
export const useHomePage = () => useContext(HomePageContext);
export default function HomePageProvider(props) {
  const [hidden, setHidden] = useState(props.initiallyHidden || false);
  const value = useMemo(() => ({
    hidden,
    setHidden
  }), [hidden]);
  return /*#__PURE__*/React.createElement(HomePageContext.Provider, {
    value: value
  }, props.children);
}